module.exports = __webpack_public_path__ + "img/default.1630993415105.png";